export default class WorkerBulkInviteSearchRequest {
    branchId: string;
    deskId: string;
}
